export enum CommodityType {
  Crude = 1,
  HeatingOil = 2,
  NaturalGas = 3,
  Gasoline = 4,
  Propane = 5,
  Ethanol = 6,
  Corn = 7,
  Wheat = 8,
  Soybeans = 9,
}
